module.exports = __webpack_public_path__ + "user-adf63de96e2ace4f8b85.png";